import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Dropdown from "../Reusablecomponents/DropDown";
import DropdownValues from "../Reusablecomponents/DropDownValues";
import axiosInstance from "../../ReusableComponents/Axios";
import notify from "../../ReusableComponents/ToastifyAlerts";
import { userDetailsData } from "../../Redux/Reducers/Logindetails";
import * as Yup from "yup";

const UpdateDetails = (props) => {
  const dispatch = useDispatch();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const [UpdateSection, SetUpdateSection] = useState("");
  const [UESubject, SetUESubject] = useState("");
  const [ESubjectS, SetESubjectS] = useState(items.electiveSubjectId);
  // const [OLSubject, SetOLSubject] = useState();
  const [OLSubject, SetOLSubject] = useState(items.languageSubjectId?.split(",").length > 1 ? "" : items?.languageSubjectId);
  const [OpenCNF, CLoseCNF] = useState(false);
  const [AQErrors, SetAQErrors] = useState({});

  const USection = async () => {
    try {
      const response = await axiosInstance.get(
        `/Assessment/UpdateStudentSection?UserId=${items.userId}&Section=${UpdateSection}`
      );
      if (response.data) {
        dispatch(
          userDetailsData({
            LoginDetails: { ...items, section: UpdateSection, studentLanguageId: OLSubject },
          })
        );
        notify("Section updated successfully", "success");
        if (items.electiveSubjectId !== 0 || items.grade <= 10) {
          props.ChangeType(false);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const GetElectiveSubject = async (data) => {
    try {
      const response = await axiosInstance.get(
        `/School/GetSubjectCategoryForGrade?LovCategoryId=67`
      );
      const Subjects = response.data
        .filter((item) => item.lovDescription !== "BioTechnology")
        .map((sub) => ({ display: sub.lovDescription, value: sub.lovId }));
      SetESubjectS(Subjects);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    GetElectiveSubject();
  }, []);

  const USubject = async () => {
    try {
      const response = await axiosInstance.get(
        `/Assessment/UpdateStudentElectiveSubject?UserId=${items.userId}&ElectiveSubjectId=${UESubject || 0}&OptionalLanguageId=${OLSubject || 0}`
      );
      if (response.data) {
        dispatch(
          userDetailsData({
            LoginDetails: { ...items, electiveSubjectId: UESubject,studentLanguageId: OLSubject },
          })
        );

        props.Updatedata();
         if (items.electiveSubjectId !== 0 || items.grade > 10) {
           notify("Elective Subject updated successfully", "success");
        }
        if(items.studentLanguageId === 0 && items.grade <= 10){
           notify("Optional Language updated successfully", "success");
        }

        props.ChangeType(false);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const validationSchema = Yup.object().shape({
    UpdateSection: Yup.string().when("2", {
      is: () => items.section === "X",
      then: (schema) => Yup.string().required("Section is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    UESubject: Yup.string().when("2", {
      is: () => items.electiveSubjectId === 0 && items.grade > 10,
      then: (schema) => Yup.string().required("Elective Subject is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    OLSubject: Yup.string().when("2", {
      is: () => items.studentLanguageId === 0 && items.grade <= 10,
      then: (schema) => Yup.string().required("Optional Language is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
  });
  const Validation = () => {
    const AllFields = {
      UpdateSection,
      UESubject,
      OLSubject
    };
    validationSchema
      .validate(AllFields, { abortEarly: false })
      .then(() => {
        SetAQErrors({});
        CLoseCNF(!OpenCNF);
      })
      .catch((err) => {
        const newErrors = {};
        if (Array.isArray(err.inner)) {
          err.inner.forEach((error) => {
            newErrors[error.path] = error.message;
          });
        }
        SetAQErrors(newErrors);
      });
  };
  const SectionOptions = [
    { display: "A", value: "A" },
    { display: "B", value: "B" },
    { display: "C", value: "C" },
    { display: "D", value: "D" },
  ];
  const GetESubjectName = () => {
    const selectedOption = ESubjectS.find(
      (opt) => opt.value === Number(UESubject)
    );
    if (selectedOption) {
      return selectedOption?.display;
    }
  };
  // const OLSubjects = async () => {
  //   try {
  //     const res = await axiosInstance.get('');
  //     if (res.data) {
  //       dispatch(
  //         userDetailsData({
  //           LoginDetails: { ...items, studentLanguageId: OLSubject },
  //         })
  //       );
  //     }
  //     props.Updatedata();
  //     notify("Optional Language updated successfully", "success");
  //     props.ChangeType(false);
  //   }
  //   catch (err) { console.log(err) }
  // }
  const OLanguage =[{display:"Hindi",value:4},{display:"Telugu",value:5}]
  return (
    <>
      <div className="Updatemodel">
        <h5>Update Details</h5>
        <div className="Inputsections">
          <div>
            <span>Grade</span>
            <input
              type="text"
              className="Search"
              value={items.grade}
              disabled="true"
            />
          </div>
          {items.section === "X" && (
            <>
              <div>
                <span>
                  Select section<span className="text-danger">*</span>
                </span>
                <DropdownValues
                  options={SectionOptions}
                  Displayname="Select Section"
                  className="NCLDropdown"
                  onChange={(e) => {
                    SetUpdateSection(e.target.value);
                  }}
                />
              </div>
              <div className="p-0">
                <span></span>
                {AQErrors?.UpdateSection && (
                  <span className="error-message">
                    {AQErrors?.UpdateSection}
                  </span>
                )}
              </div>
            </>
          )}
          {items.electiveSubjectId === 0 && items.grade > 10 && (
            <>
              <div>
                <span>
                  Select Elective Subject<span className="text-danger">*</span>
                </span>
                <DropdownValues
                  options={ESubjectS}
                  Displayname="Select Subject"
                  className="NCLDropdown"
                  onChange={(e) => {
                    SetUESubject(e.target.value);
                  }}
                />
              </div>
              <div className="p-0">
                <span></span>
                {AQErrors?.UESubject && (
                  <span className="error-message">{AQErrors?.UESubject}</span>
                )}
              </div>
            </>
          )}

          {items.studentLanguageId === 0 &&items.grade <= 10 && (items.instituteId == 1 || items.instituteId == 4 ||items.instituteId == 8) && (
            <>
              <div>
                <span>
                  Select Optional Language<span className="text-danger">*</span>
                </span>
                <DropdownValues
                  // options={[{display:"Hindi",value:4},{display:"Telugu",value:5}]}
                  options={items.languageSubjectName?.split(",").map((OL, Index) => ({ display: OL, value: items.languageSubjectId?.split(",")[Index] }))}
                  Displayname="Select Optional Language"
                  className="NCLDropdown"
                  onChange={(e) => { SetOLSubject(e.target.value); }}
                />
              </div>
              <div className="p-0">
                <span></span>
                {AQErrors?.OLSubject && (
                  <span className="error-message">{AQErrors?.OLSubject}</span>
                )}
              </div>
            </>
          )}
          <button
            className="Buttons mt-2"
            onClick={() => {
              Validation();
              // CLoseCNF(!OpenCNF);
              // if (items.section === "X") {
              //     USection();
              // }
              // if (items.electiveSubjectId === 0) {
              //     USubject();
              // }
            }}
          >
            Update
          </button>
        </div>

        {OpenCNF && (
          <div className="Model-Open">
            <div className="Card">
              You have selected{" "}
              {OLSubject && <><b>{OLanguage.filter((OL)=>OL.value == OLSubject )?.[0]?.display}</b> as your optional subject </> }
              {UESubject && (
                <>
                  <b>{GetESubjectName()}</b> as your elective subject
                </>
              )}{" "}
              {UESubject && UpdateSection && `and`}{" "}
              {UpdateSection && (
                <>
                  <b>{UpdateSection}</b> as section
                </>
              )}
              . Please click Ok to confirm or Cancel to select again.
              <div className="dflex gap-3" style={{ justifyContent: "end" }}>
                <button
                  className="Buttons"
                  onClick={() => {
                    USection();
                    USubject();
                  }}
                >
                  ok
                </button>
                <button
                  className="Buttons bg-danger"
                  onClick={() => CLoseCNF(!OpenCNF)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default UpdateDetails;
